import React from "react";
import BlackLogo from "./Images/BlackLogo.png";
import { Link } from "react-router-dom";

export default class UnderConstruction extends React.Component {
	componentDidMount() {
		window.scroll(0,0);
	}
	render() {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					width: "100%",
					height: "100%",
					position: "relative",
					color: "white",
				}}
			>
				<div
					style={{
						width: "100%",
						position: "relative",
						backgroundImage:
							'url("https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fbestanimations.com%2FSite%2FConstruction%2Funder-construction-animated-gif-16.gif&f=1&nofb=1")',
						backgroundSize: "cover",
					}}
				>
					<h1
						style={{
							margin: "20rem 0",
							fontSize: "8rem",
							fontFamily: "Poppins",
							textAlign: "center",
							WebkitTextStroke: "2px #8c8c8c",
						}}
					>
						Site under construction!
					</h1>
				</div>
				<Link to="/">
					<img
						className="under-work-logo"
						style={{
							width: "10rem",
							position: "absolute",
							top: "10px",
							left: "10px",
						}}
						src={BlackLogo}
					/>
				</Link>
				<div
					style={{
						width: "100%",
						backgroundImage:
							'url("https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.tenor.co%2Fimages%2F0fd922f2ce1ad665146f2daab7d21b11%2Fraw&f=1&nofb=1")',
						backgroundSize: "cover",
						position: "relative",
					}}
				>
					<h1
						style={{
							margin: "20rem 0",
							fontSize: "8rem",
							fontFamily: "Poppins",
							textAlign: "center",
							WebkitTextStroke: "2px #8c8c8c",
						}}
					>
						🚀Winners under work!
					</h1>
				</div>
			</div>
		);
	}
}
